// The membership-role vocabulary the MVP fixes (the company account model),
// in one place because four surfaces now compare against it: the page's admin derivation, the
// /c switcher, the member editor and the acting-company bar.
//
// `role` is an OPEN string in genesis — §4 requires later roles (content, analyst) to be addable
// without a structural migration, and @external-adr GENESIS-0023-company-membership-is-the-per-company-authorization §2 keeps the column `text` with no check constraint
// for exactly that reason. So these are the two values spark KNOWS, never the two values that
// exist: nothing may switch on them exhaustively, and an unrecognised role must degrade to "not an
// admin" and to no label rather than reaching the user as a raw genesis string.
//
// Comparing against `admin` is presentation only wherever it happens. genesis re-reads the row on
// every mutation (@external-adr GENESIS-0023-company-membership-is-the-per-company-authorization §1), so a wrong answer here changes what a button looks like and never
// what a write is allowed to do.

/** genesis's "may administer this company" role (@external-adr GENESIS-0023-company-membership-is-the-per-company-authorization §1). */
export const COMPANY_ROLE_ADMIN = "admin";

/** The other role the MVP vocabulary knows (the company account model): belongs, cannot administer. */
export const COMPANY_ROLE_MEMBER = "member";

/** The two the MVP writes. Reads must tolerate any string; writes use only these. */
export const COMPANY_ROLES = [COMPANY_ROLE_ADMIN, COMPANY_ROLE_MEMBER] as const;

export type CompanyRole = (typeof COMPANY_ROLES)[number];
